<template>
  <v-layout column>
    <v-layout
      v-if="totalItems"
      class="pa-4"
      column
    >
      <v-card
        class="application-item mb-4"
        v-for="(infraction_notice, index) in infraction_notices"
        :key="index"
      >
        <v-toolbar color="teal darken-4" dark>
          <v-toolbar-side-icon left>{{infraction_notice.application_type.acronym}}</v-toolbar-side-icon>
          <v-toolbar-title>{{infraction_notice.application_type.name}}</v-toolbar-title>
        </v-toolbar>

        <v-list two-line subheader>
          <v-list-tile avatar @click="showApplication(infraction_notice)">
            <v-list-tile-avatar>
              <v-icon>{{ personalTypeIcon(infraction_notice) }}</v-icon>
            </v-list-tile-avatar>

            <v-list-tile-content>
              <v-list-tile-title>{{infraction_notice.person.name}}</v-list-tile-title>
              <v-list-tile-sub-title>
                {{ processCpfCnpj(infraction_notice.person) }}
              </v-list-tile-sub-title>
            </v-list-tile-content>

            <v-list-tile-action right v-if="infraction_notice.badge">
              <small :class="`badge ${infraction_notice.badge.color}`">
                {{ infraction_notice.badge.text }}
              </small>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
      </v-card>

      <v-layout
        v-if="totalPages"
        justify-center
        align-center
      >
        <v-pagination class="align-self-center"
          color="teal darken-4"
          v-model="activePage"
          :length="totalPages"
          total-visible="5"
          circle
        />
      </v-layout>
    </v-layout>

    <v-card v-if="!infraction_notices.length">
      <v-card-text>
        <v-layout
          class="empty-list"
          justify-center
          align-center
          column
        >
          <img
            class="mb-3 icon"
            src="@/assets/image/icon/leaf.svg"
            alt="Ícone Ambiental"
            width="320"
          >
          <h1 class="heading">Não há auto de infração para exibir</h1>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-layout>
</template>

<script>
import CPF_CNPJ from 'cpf_cnpj';

export default {
  name: 'InfractionNoticesList',
  props: {
    infraction_notices: {
      type: Array,
      default: () => [],
    },
    totalPages: {
      type: Number,
      default: 0,
    },
    page: {
      type: Number,
      default: 1,
    },
    totalItems: {
      type: Number,
      default: 0,
    }
  },
  data() {
    return {
      activePage: this.page,
    }
  },
  created() {
    let badge = {
      'waiting_to_be_sent': {
        text: 'AGUARDANDO ENVIO', color: 'grey'
      },
      'waiting_for_review': {
        text: 'ANÁLISE EM ANDAMENTO', color: 'amber'
      },
      'in_review': {
        text: 'EM ANÁLISE', color: 'amber'
      },
      'pending': {
        text: 'PENDENTE', color: 'red'
      },
      'done': {
        text: 'APROVADO', color: 'green'
      }
    };
    this.infraction_notices.map((infraction_notice) => infraction_notice.badge = badge[infraction_notice.status])
  },
  methods: {
    showApplication(infraction_notice) {
      this.$store.dispatch('setLoadingDialog', true);
      this.$router.push(`${infraction_notice.id}/visualizar`);
    },
    personalTypeIcon(infraction_notice) {
      return infraction_notice.person.person_type === 'physical_person' ? 'mdi-account' : 'mdi-domain';
    },
    processCpfCnpj(person) {
      if (person.person_type === 'physical_person') {
        return `CPF: ${CPF_CNPJ.CPF.format(person.cpf_cnpj)}`;
      }
      return `CNPJ: ${CPF_CNPJ.CNPJ.format(person.cpf_cnpj)}`;
    },
  },
  watch: {
    activePage() {
      this.$emit('changePage', this.activePage);
    }
  }
};
</script>
